import React from 'react'
import './footer.css'

function Footer() {
    return (
        <div className="footer">
            Made With ReactJS  By Leslie D. Shumba .
        </div>
    )
}

export default Footer
